/**
 * @file actions/Personalization/constants.js
 * @copyright 2018 CBC/Radio-Canada. All rights reserved.
 * @author Khalil Chatoo [khalil.chatoo@cbc.ca]
 */

export const REC_FOR_YOU_DEFAULT_SIZE = 5;
export const RECOMMENDED_FOR_YOU_AB_TESTS_KEY = "story-page-recsys";
export const REC_FOR_YOU_DEFAULT_ALGORITHM_ID = "rec4you-english-all-articles";
